import { useEffect, useState } from "react";
import { TListener } from "@/types";
import { User } from "@/types/user.ts";
import { getUser } from "@/api/getUser.ts";
import { getClients } from "@/api/getClients.ts";
import { Client } from "@/types/client.ts";

interface UserWithClients extends User {
  clients: Client[];
}

let _user: UserWithClients | null = null;
let listeners: TListener<UserWithClients | null>[] = [];

const fetchUser = async () => {
  try {
    const [userResponse, clientsResponse] = await Promise.all([
      getUser(),
      getClients(),
    ]);
    _user = { ...userResponse.data, clients: clientsResponse.data };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    //TODO
  }
};

const updateListeners = () => {
  if (listeners.length > 0) {
    listeners.forEach((listener) => listener(_user));
  }
};

export const updateUser = async () => {
  await fetchUser();
  updateListeners();
};

export const clearUser = () => {
  _user = null;
  updateListeners();
};

export const useUser = () => {
  const [state, setState] = useState(_user);
  useEffect(() => {
    listeners.push(setState);
    return () => {
      listeners = listeners.filter((listener) => listener !== setState);
    };
  }, []);
  return state;
};
